package io.eqoty.shared.datalayer.sources

sealed interface DataSrc
sealed interface LocalSrc : DataSrc
sealed interface RemoteSrc : DataSrc
object ALL : LocalSrc, RemoteSrc
object LOCAL : LocalSrc
object REMOTE : RemoteSrc